import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useFetchApi, Config, useRedirect } from "@itarget/shared";

export function useReRegisterRedirect({ enabled = true, delay = 2000 } = {}) {
  const centerCostId = useSelector((state) => state.auth.cc);
  const user = useSelector((state) => state.auth.user);
  const selectedLang = useSelector((state) => state.language.lang);
  const { goTo } = useRedirect();

  const { data: reRegister, fetchData: fetchReRegister } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/person/re/register?pessoa_id=${user?.data?.id}&centro_custo_id=${centerCostId}&aplicacoes=4`
  );

  useEffect(() => {
    if (enabled && user?.data?.id) fetchReRegister();
    // eslint-disable-next-line
  }, [user?.data?.id, enabled]);

  useEffect(() => {
    if (!enabled) return;
    const firstItem = reRegister?.data?.length ? reRegister.data.slice(0, 1).shift() : undefined;
    if (firstItem) {
      const timeout = setTimeout(() => goTo("me"), delay);
      return () => clearTimeout(timeout);
    }
  }, [reRegister, goTo, enabled, delay]);
} 